import React from "react";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import DnsIcon from "@material-ui/icons/Dns";
import { makeStyles } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { Load_Data_Action, Logout_Succes_Action } from "../redux/actions";
import { useDispatch } from "react-redux";
import history from './history';
import { useSelector } from "react-redux";

const useStyles = makeStyles(() => ({
  typographyStyles: {
    flex: 1,
    padding: 4,
  },
  header: {
    minHeight: "10vh",
  },
}));

const Header = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);  
  const dispatch = useDispatch();
  const authIndicator = useSelector((state) => {
    if (state.loginSuccesReducer != null)
      return state.loginSuccesReducer.data.isLoggedIn;
    else return false;
  });
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const showProfile = () => {
    //window.location = "/profile";
    history.push("/profile");
    setAnchorEl(null);
  };
  const logout = () => {
    dispatch(Logout_Succes_Action({ isLoggedIn: false }));
    dispatch(Load_Data_Action({}));
    //window.location = "/";
    history.push("/");
    setAnchorEl(null);
  };
  let profileIcon=null;
 
  if(authIndicator){
    profileIcon=(
     
        <Menu
          id="profile-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={showProfile}>My Profile</MenuItem>
          <MenuItem onClick={logout}>Logout</MenuItem>
        </Menu>
     
    );
  }
  return (
    <div>
    <AppBar position="static" color="primary" className={classes.header}>
      <Toolbar>
        <DnsIcon />
        <Typography variant="h6" className={classes.typographyStyles}>
          HLSC Server Inventory
        </Typography>
        <PersonIcon onClick={handleClick}></PersonIcon>
      </Toolbar>
    </AppBar>
   {profileIcon}
    </div>
  );
};
export default Header;
